import { auth } from "../firebaseConfig";
import { API_BASE_URL } from "./apiBase";

const API_BASE = API_BASE_URL;

export async function createQuizApi(mode, quiz, requestState) {
  const user = auth.currentUser;
  if (!user) throw new Error("Please sign in again before creating a test.");
  const payloadKey = JSON.stringify([mode, quiz]);
  if (!requestState.current || requestState.current.payloadKey !== payloadKey) {
    requestState.current = { payloadKey, requestId: crypto.randomUUID() };
  }
  const response = await fetch(`${API_BASE}/api/quizzes/create`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${await user.getIdToken()}` },
    body: JSON.stringify({ mode, ...quiz, requestId: requestState.current.requestId }),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok || result.ok !== true) {
    const error = new Error(result.error || "Could not create the test. Please try again.");
    error.code = result.code;
    throw error;
  }
  return result;
}
